import ProductList from "./ProductList";
import { myProductsLabel } from "../settings";

function ProductListPage () {
    return (
        <div className='product-list-wrapper'>
            <h1 className='page-title'>{myProductsLabel}</h1>
            <ProductList/>
        </div>
    )
}
export default ProductListPage